import { render } from "./PhotoCoverageAlertComponent.vue?vue&type=template&id=1262c5c8&scoped=true"
import script from "./PhotoCoverageAlertComponent.vue?vue&type=script&lang=js"
export * from "./PhotoCoverageAlertComponent.vue?vue&type=script&lang=js"

import "./PhotoCoverageAlertComponent.vue?vue&type=style&index=0&id=1262c5c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1262c5c8"]])

export default __exports__